//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'

export class OpLocationStateType implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idLocationStateType: number
    public name: string
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdLocationStateType
    }
    public getReferenceKey(): number {
        return this.idLocationStateType
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idLocationStateType = opObj.IS
                this.name = opObj.N
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
            } else {
                this.idLocationStateType = opObj.ID_LOCATION_STATE_TYPE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IS: this.idLocationStateType,
                N: this.name,
                I: this.idDescr,
                D: this.descr ? this.descr.toJSON(compressed) : null,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                ID_LOCATION_STATE_TYPE: this.idLocationStateType,
                NAME: this.name,
                ID_DESCR: this.idDescr,
                _Descr: this.descr ? this.descr.toJSON(compressed) : null,
                OpState: this.opState
            }
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpLocationStateType[]): JQueryPromise<OpLocationStateType[]> {
        var defered = $.Deferred<OpLocationStateType[]>()

        defered.resolve(list)

        return defered.promise()
    }
}